import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	inject,
	Input,
	Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { negativeHeader$ } from '@valk-nx/core/lib/core';
import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';

import { HeaderDesktopComponent } from './header-desktop/header-desktop';
import { HeaderMobileComponent } from './header-mobile/header-mobile';
import { HeaderMenuItem, MetaMenu } from './header.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-header`,
	templateUrl: './header.component.html',
	imports: [CommonModule, HeaderDesktopComponent, HeaderMobileComponent],
})
export class HeaderComponent extends BaseDirective {
	private readonly cd = inject(ChangeDetectorRef);

	@Input() title = '';
	@Input() menuItems: HeaderMenuItem[];
	@Input() metaMenu: MetaMenu;
	@Input() hideMenu = false;

	@Output() languageSwitch = new EventEmitter<string>();

	isNegativeHeader = false;

	constructor() {
		super();

		negativeHeader$.pipe(takeUntilDestroyed()).subscribe((isNegative) => {
			this.isNegativeHeader = isNegative;
			this.cd.markForCheck();
		});
	}

	onLanguageSwitch(language: string) {
		this.languageSwitch.emit(language);
	}
}
